import React, { useState, createContext, useCallback, useMemo } from 'react';
import { MessageType } from '../types/message';

interface MessageContextType {
  text: string | null;
  type: MessageType | undefined;
  showMessage: (text: string, type: MessageType | undefined) => void;
  clearMessage: () => void;
}

export const MessageContext = createContext<MessageContextType>({
  text: null,
  type: undefined,
  showMessage: () => {},
  clearMessage: () => {},
});

export const MessageProvider = ({ children }) => {
  const [text, setText] = useState<string | null>(null);
  const [type, setType] = useState<MessageType | undefined>(undefined);

  const showMessage = useCallback((newText: string, newType: MessageType | undefined) => {
    setText(newText);
    setType(newType);
  }, []);

  const clearMessage = useCallback(() => {
    setText(null);
    setType(undefined);
  }, []);

  const value = useMemo(
    () => ({ text, type, showMessage, clearMessage }),
    [text, type, showMessage, clearMessage]
  );

  return <MessageContext.Provider value={value}>{children}</MessageContext.Provider>;
};
